





























import { Vue, Component } from 'vue-property-decorator';
import DashboardServices from '@/services/dashboard';
import { getRange } from '@/libs/time';
import LabelTag from './LabelTag.vue';
import { sleep } from '@/libs/util';
@Component({
  components: { LabelTag }
})
export default class BottomCharts extends Vue {
  dashSrv = new DashboardServices();
  config0: any = {
    data: [
      { name: '一级预警', value: 0 },
      { name: '二级预警', value: 0 },
      { name: '三级预警', value: 0 }
    ],
    color: ['#d50000', '#fc7c0d', '#ffea00'],
    lineWidth: 30,
    radius: '55%',
    activeRadius: '60%'
  };
  config1: any = {
    data: [
      { name: '一级预警', value: 0 },
      { name: '二级预警', value: 0 },
      { name: '三级预警', value: 0 }
    ],
    color: ['#d50000', '#fc7c0d', '#ffea00'],
    lineWidth: 30,
    radius: '55%',
    activeRadius: '60%'
  };
  config2: any = {
    data: [
      { name: '一级预警', value: 0 },
      { name: '二级预警', value: 0 },
      { name: '三级预警', value: 0 }
    ],
    color: ['#d50000', '#fc7c0d', '#ffea00'],
    lineWidth: 30,
    radius: '55%',
    activeRadius: '60%'
  };
  config3: any = {
    data: [
      { name: '一级预警', value: 0 },
      { name: '二级预警', value: 0 },
      { name: '三级预警', value: 0 }
    ],
    color: ['#d50000', '#fc7c0d', '#ffea00'],
    lineWidth: 30,
    radius: '55%',
    activeRadius: '60%'
  };

  labelConfig = {
    data: ['红色警告（一级预警）', '橙色警示（二级预警）', '黄色提醒（三级预警）']
  };

  showChart: boolean = false;
  created() {
    let [startTime, endTime] = getRange('total');
    this.showChart = false;
    this.getManagePlate({ startTime, endTime });
  }

  async getManagePlate(params?: any) {
    let list = await this.dashSrv.getManagePlate(params);
    list.forEach((v: any) => {
      if (v.name === '渠道板块') this.config0 = this.packConfig(v);
      if (v.name === '市场板块') this.config1 = this.packConfig(v);
      if (v.name === '风险板块') this.config2 = this.packConfig(v);
      if (v.name === '运营板块') this.config3 = this.packConfig(v);
    });
    this.showChart = true;
  }

  packConfig(data: any) {
    return {
      data: [
        {
          name: '一级预警',
          value: data.oneLevelTotal
        },
        {
          name: '二级预警',
          value: data.twoLevelTotal
        },
        {
          name: '三级预警',
          value: data.threeLevelTotal
        }
      ],
      showOriginValue: true,
      color: ['#d50000', '#fc7c0d', '#ffea00'],
      lineWidth: 30,
      radius: '55%',
      activeRadius: '60%'
    };
  }
}
